<template>
    <div class="MobileMenu">
        <div class="MobileMenu-header">
            <f2mLogo />
            <FlagSelect
                :country="$country"
                data-cy="select.flag"
                @flagSelected="flagSelected"
            />
        </div>
        <div class="MobileMenu-body">
            <MobileMenuBlock
                :withSubMenu="true"
                :label="$t('personal-account.mobileMenu.myAccount')"
                :subMenu="[{
                               'label': $t('personal-account.mobileMenu.myProfile'),
                               'type': 'routeName',
                               'target': 'personalAccountProfile',
                               'iconClass': 'f2m-user'
                           },
                           {
                               'label': $t('personal-account.mobileMenu.yourInvoices'),
                               'type': 'routeName',
                               'target': 'personalAccountInvoices',
                               'iconClass': 'f2m-invoice'
                           },
                           {
                               'label': $t('personal-account.mobileMenu.coupons'),
                               'type': 'routeName',
                               'target': 'personalAccountCoupons',
                               'iconClass': 'f2m-rounded-percent'
                           },
                           {
                               'label': $t('personal-account.mobileMenu.bookings'),
                               'type': 'routeName',
                               'target': 'personalAccountBookings',
                               'iconClass': 'f2m-calendar'
                           },
                           {
                               'label': $t('personal-account.mobileMenu.yourCarOnDemand'),
                               'type': 'link',
                               'target': '/cod/contracts',
                               'iconClass': 'f2m-cod-car'
                           },
                           {
                               'label': $t('personal-account.mobileMenu.settings'),
                               'type': 'routeName',
                               'target': 'personalAccountSettings',
                               'iconClass': 'f2m-setting'
                           },
                ]"
                data-cy="mobile-menu.my-account"
                @hideMenu="hideMenu"
            />
            <MobileMenuBlock
                :withSubMenu="false"
                :link="{
                    'label': $t('personal-account.mobileMenu.carSharing'),
                    'type': 'link',
                    'target': getLink($alternateLinksOthers['car-sharing'])
                }"
                data-cy="mobile-menu.car-sharing"
            />
            <MobileMenuBlock
                :withSubMenu="false"
                :link="{
                    'label': $t('personal-account.mobileMenu.chargeMyCar'),
                    'type': 'link',
                    'target': getLink($alternateLinksOthers['charge-my-car'])
                }"
                data-cy="mobile-menu.charge-my-car"
            />
            <MobileMenuBlock
                :withSubMenu="false"
                :link="{
                    'label': $t('personal-account.mobileMenu.carRental'),
                    'type': 'link',
                    'target': getLink($alternateLinksOthers['car-rental'])
                }"
                data-cy="mobile-menu.car-rental"
            />
            <MobileMenuBlock
                :withSubMenu="false"
                :link="{
                    'label': $t('personal-account.mobileMenu.parkingLot'),
                    'type': 'link',
                    'target': getLink($alternateLinksOthers['parking-lot'])
                }"
                data-cy="mobile-menu.parking-lot"
            />
            <MobileMenuBlock
                :withSubMenu="false"
                :link="{
                    'label': $t('personal-account.mobileMenu.businessSolutions'),
                    'type': 'link',
                    'target': getLink($alternateLinksOthers['business-solutions'])
                }"
                data-cy="mobile-menu.business-solutions"
            />
        </div>
    </div>
</template>
<script>
import f2mLogo from '@/assets/images/F2M-white.svg';
import MobileMenuBlock from "@/components/MobileMenuBlock.vue";
import {mapState} from "vuex";
import _ from 'lodash';
import FlagSelect from "@/components/common/FlagSelect.vue";
import {getSlug} from "@/router";
export default {
    components: {
        FlagSelect,
        f2mLogo,
        MobileMenuBlock
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapState(['isAuthenticated']),
    },
    mounted() {

    },
    methods:
    {
        hideMenu() {
            this.$emit('hideMenu');
        },
        getLink(alternateLinks) {
            return _.get(_.find(alternateLinks, {country:this.$country, language: this.$language}), 'link')
        },
        flagSelected(country) {
            const slug = getSlug(country.split('-')[0], country.split('-')[1], this.$route.name);
            window.location.href = `${this.$appBaseUrl}/${country}/${slug}`;
        }
    }
}
</script>
<style lang="scss" scoped>
.MobileMenu {
    overflow-y: auto;
    height: 100vh;
    padding: 28px 28px 120px;
    &-header {
        display: flex;
        align-items:center;
        gap: 16px;
    }
    &-loginContainer {
        margin-top: 28px;
        display: flex;
        gap: 16px;
    }
    &-btnLogin {
        width: 60%;
        font-weight: bold;
    }
    &-btnSignUp {
        width: 40%;
        font-weight: bold;
    }

    &-body {
        padding-top: 14px;
    }
}
</style>

